export default class PubmedService {
  async getResources(url) {
    const res = await fetch(url);

    if (!res.ok)
    {
      throw new Error(`Could not fetch ${test}`);
    }

    return await res.json();
  }

  EBIFetch = async (value, cursor = "*") => {
    const url = this.editValueFetch(value, cursor);

    const res = await this.getResources(url);
    return this._transformText(res);
  };

  editValueFetch = (value, cursor) => {
    const editText = value.replace(/ /g, "+");
    const url = `https://www.ebi.ac.uk/europepmc/webservices/rest/search?query=${editText}&resultType=core&cursorMark=${cursor}&pageSize=10&format=json`;

    return url;
  };

  _transformText(text) {
    let cursor = text.nextCursorMark;
    let query = text.request.query;
    let newArray = [...text.resultList.result];
    let request = text.request.query;
    return newArray.map(function (item) {
      let filterObj = {
        title: item.title,
        body: item.abstractText,
        id: item.pmid,
        authorString: item.authorString,
        affiliation: item.affiliation,
        request: request,
        doi: item.doi,
        firstPublicationDate: item.firstPublicationDate,
        keyword: { ...item.keywordList }.keyword,
        fullText: { ...item.fullTextUrlList }.fullTextUrl,
        cursor,
        query,
      };
      return filterObj;
    });
  }
}
